import { useToast } from '@ouster/webviz-react-components';

import React, { useCallback, useRef } from 'react';

type ToastStatus = 'info' | 'warning' | 'success' | 'error' | 'loading';
type ToastProps = {
  title: string;
  description: React.ReactNode;
  status: ToastStatus;
  isStay?: boolean;
  closeOnOutsideClick?: boolean;
};

/**
 *
 */
function useChakraHook() {
  const toast = useToast();
  const toastIdRef = useRef<string | undefined>(undefined);

  /* 
    Wrapper the showToast in useCallback so it won't cause unnecessary re-render
  */
  const showToast = useCallback(
    ({
      title,
      description,
      status,
      isStay = false,
      closeOnOutsideClick = false,
    }: ToastProps) => {
      toastIdRef.current = toast({
        title,
        description,
        status,
        duration: status === 'error' || isStay ? null : 5000,
        isClosable: true,
        position: 'top',
      }).toString();

      if (closeOnOutsideClick) {
        const handleClickOutside = () => {
          if (!toastIdRef.current) return;

          if (toastIdRef.current) {
            toast.closeAll();
            document.removeEventListener('mousedown', handleClickOutside);
          }
        };

        document.addEventListener('mousedown', handleClickOutside);
      }
    },
    [toast] // Adding toast to the dependency array
  );

  return { showToast };
}

export default useChakraHook;
